export default "__VITE_ASSET__Dm42U5f4__"